import React, { useState, useCallback } from 'react';
import { log } from 'log';
import { prop } from 'ramda';
import { useTranslations } from '@core/js/hooks/i18n';
import { useAppSelector } from '@core/js/store/hooks';

import { Control } from '@core/js/components/common/Fields/Control';
import withField from '@core/js/components/common/Fields/withField';
import ValidationIcon from '@core/js/components/common/Fields/Icons/ValidationIcon';
import VisibilityIcon from '@core/js/components/common/Fields/Icons/VisibilityIcon';
import { InputShallow } from '@core/js/components/common/Fields/Input/components/InputShallow';

// TODO CODERE: Check why this override is equal, might loose some functionality
export const InputBare = ({
    /* rff render props */
    input,
    meta,

    /* user provided props */
    id,
    name,
    label,
    hint,
    readOnly,
    bottomHint,
    type = 'text',
    className = '',
    classNames,
    onClick,
    infoTooltip,
    currencySymbol,
    onMouseDown,
    placeholder = '',
    isLabelAsteriskEnabled,
    isPlaceholderAsteriskEnabled,
    escapeSymbolsRegExp,
    // #region @theme
    labelClass,
    controlClass,
    // #endregion
    ...inputDomProps
}) => {
    const translate = useTranslations('playtech.mobile.system.input.');
    const { active, touched, error, validating, submitting } = meta;
    const isEnablePasswordSpy = useAppSelector(prop('isEnablePasswordSpy'));
    const showPasswordIcon = isEnablePasswordSpy && type === 'password';
    const [isVisible, setIsVisible] = useState(false);
    const toggleVisible = () => setIsVisible(!isVisible);
    const dataCurrencyAttribute = currencySymbol ? { 'data-currency-symbol': currencySymbol } : {};
    const preventClick = useCallback(event => event.preventDefault(), []);

    const onInput = useCallback((event) => {
        if (escapeSymbolsRegExp) {
            try {
                event.target.value = event.target.value.replace(new RegExp(escapeSymbolsRegExp), '');
            } catch (err) {
                log('error', err);
            }
        }

        input.onInput?.(event);
    }, [escapeSymbolsRegExp, input]);

    return (
        <Control {...{
            id,
            meta,
            readOnly,
            className,
            classNames,
            onClick,
            label,
            hint,
            bottomHint,
            animate: true,
            infoTooltip,
            isLabelAsteriskEnabled,
            // #region @theme
            labelClass,
            controlClass,
            // #endregion
            ...dataCurrencyAttribute
        }}>
            <InputShallow
                {...input}
                {...inputDomProps}
                id={id}
                name={name}
                readOnly={readOnly}
                tabIndex={readOnly ? -1 : 0}
                type={isVisible ? 'text' : type}
                aria-label={inputDomProps['aria-label'] || translate('playtech.mobile.system.input.aria-label')}
                {...(submitting || validating) && { disabled: true }}
                onMouseDown={readOnly ? preventClick : onMouseDown}
                placeholder={`${placeholder}${isPlaceholderAsteriskEnabled ? '*' : ''}`}
                {...escapeSymbolsRegExp ? { onInput } : {}}
            />

            {touched && !active && !validating && !readOnly && (
                <ValidationIcon
                    animate={true}
                    isValid={!error}
                    aria-label={error}
                    tabIndex={error ? 0 : -1}
                    className={classNames?.validationIcon}
                />
            )}

            {showPasswordIcon && (
                <VisibilityIcon
                    onClick={toggleVisible}
                    isVisible={isVisible}
                    aria-label={isVisible
                        ? translate('password.aria-label.hide')
                        : translate('password.aria-label.show')
                    }
                />
            )}
        </Control>
    );
};

export const Input = withField(InputBare);
